<!--
 * @Description: 折线图
 * @Author: mdb
 * @Date: 2022-11-28 11:30:34
 * @LastEditTime: 2022-11-29 11:02:14
 * @LastEditors: mdb
-->
<template>
  <div ref="chartRef" :style="{ width, height }" v-if="showECharts"></div>
  <Empty :style="{ width, height }" v-if="!showECharts" />
</template>
  
  <script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import removeTrailingZeros from '@/utils/format'
import Empty from './Empty.vue'
const props = defineProps({
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '300px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  },
  isPercentageY: {
    type: Boolean as PropType<boolean>,
    default: () => {
      return false
    }
  }
})
const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
watch(
  () => props.data,
  (v) => {
    initChart()
  }
)

const initChart = () => {
  showECharts.value = props.data.length > 0
  setOptions({
    grid: {
      left: '2%',
      right: '2%',
      bottom: '1%',
      // top: '8%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: '#fff'
      },
      formatter: function (params) {
        return props.data[params[0].dataIndex].tooltip
      }
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: props.data.map((item) => item.name)
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: function (value, index) {
          return props.isPercentageY ? `${removeTrailingZeros((value * 100).toFixed(2))}%` : `${value}`
        }
      }
    },
    series: [
      {
        type: 'line',
        smooth: true,
        data: props.data.map((item) => item.value),
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#BEE3F8B2'
              },
              {
                offset: 1,
                color: '#BEE3F800'
              }
            ]
          }
        }
      }
    ]
  })
}

onBeforeMount(() => {
  initChart()
})
</script>
  <script lang="ts">
export default { name: 'BoardLineChart' }
</script>
  
  <style scoped></style>
  